const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiRoutes = {
  login: `${BASE_URL}admin/adminLogin`,
  sendOtp: `${BASE_URL}admin/send-otp`,
  userList: `${BASE_URL}admin/users-list`,
  userDestroy: `${BASE_URL}admin/user-destroy`,
  fileUpload: `${BASE_URL}admin/upload-profile`,
  UpdateUserProfile: `${BASE_URL}admin/update-user-profile`,

  userCreate: `${BASE_URL}admin/createUser`,
  viewUser: `${BASE_URL}admin/view-user`,
  userUpdate: `${BASE_URL}admin/update-profile`,
  tales: `${BASE_URL}admin/tales`,
  taleStatus: `${BASE_URL}admin/update-tale-status`,
  taleDestroy: `${BASE_URL}admin/tale-destroy`,
  adminAIGeneratedStories: `${BASE_URL}admin/aigeneratedstories`,
  aiTaleDestroy: `${BASE_URL}admin/ai-tale-destroy`,
  taleDetail: `${BASE_URL}admin/tale-detail`,
  adminCharactersList: `${BASE_URL}admin/characters-list`,
  updateCharacterStatus: `${BASE_URL}admin/update-character-status`,
  characterDestroy: `${BASE_URL}admin/character-destroy`,
  adminCharacterDetail: `${BASE_URL}admin/character-detail`,
  adminMostPopularTales: `${BASE_URL}admin/most-popular-tales`,
  adminNotifications: `${BASE_URL}admin/notifications`,
  adminNotificationDetails: `${BASE_URL}admin/notification-details`,
  adminSendNotification: `${BASE_URL}admin/send-notification`,
  adminNotificationDestroy: `${BASE_URL}admin/notification-destroy`,
  adminRevenueReports: `${BASE_URL}admin/revenue-reports`,
  adminReportDetail: `${BASE_URL}admin/report-detail`,
  adminReports: `${BASE_URL}admin/reports`,
  adminSendMail: `${BASE_URL}admin/send-mail`,
  adminMarkResolve: `${BASE_URL}admin/mark-resolve`,
  adminSubscribersList: `${BASE_URL}admin/subscribers-list`,
  adminDeleteSubscriber: `${BASE_URL}admin/delete-subscriber`,
  adminSubscriptionsPackage: `${BASE_URL}admin/subscriptions-package`,
  adminUpdateSubscriptionPackage: `${BASE_URL}admin/update-subscription-package`,
  adminFeedbacks: `${BASE_URL}admin/feedback`,
  adminFeedbackDestroy: `${BASE_URL}admin/feedback-destroy`,
  adminFeedbackDetail: `${BASE_URL}admin/feedback-detail`,
  adminSupport: `${BASE_URL}admin/support`,
  adminSupportDestroy: `${BASE_URL}admin/support-destroy`,
  adminSupportDetail: `${BASE_URL}admin/support-detail`,
  adminSupportResolve: `${BASE_URL}admin/support-resolve`,
  adminProfile: `${BASE_URL}admin/profile`,
  adminUpdateProfile: `${BASE_URL}admin/update-profile`,
  adminPasswordChange: `${BASE_URL}admin/passwordChange`,

  adminDashboard: `${BASE_URL}admin/dashboard`,
  adminUserStats: `${BASE_URL}admin/user-stats`,
  adminRevenueStats: `${BASE_URL}admin/get-revenue-stats`,
  userBooksList:`${BASE_URL}admin/user-books-list`,
  booksDetail:`${BASE_URL}admin/book-detail`,
  chapterDetail:`${BASE_URL}admin/chapter-detail`,
  booksList:`${BASE_URL}admin/books-list`,
  userTaleListByType:`${BASE_URL}admin/user-tales-list-by-type`,
  userCharacterList:`${BASE_URL}admin/user-characters-list`,
  userFollowerList:`${BASE_URL}admin/user-follower-list`,
  userFollowingList:`${BASE_URL}admin/user-following-list`,
  userAigeneratedStories:`${BASE_URL}admin/user-aigenerated-stories`,
  aigeneratedStoriesDetail:`${BASE_URL}admin/aigenerated-stories-detail`,
  getCms:`${BASE_URL}admin/get-cms`,
  updateCms:`${BASE_URL}admin/update-cms-content`,









  




  
};

export default apiRoutes;
